//* 서버 에러 응답에서 사람에게 보여줄 안내문 꺼내기

/**
 * 서버가 준 안내문을 그대로 쓴다 (전역 필터가 code 를 지워 message 만 남는다).
 * 문자열 message 가 없으면 fallback.
 *
 * 관련 메모: 백엔드 전역 필터가 `error: exception.name` 으로 덮어써 커스텀 코드는 오지 않고
 * message 만 살아남으므로, 코드 기반 분기는 설계하지 말고 message 로만 안내한다.
 */
export const errorMessageOf = (err: unknown, fallback: string): string => {
  const message = (err as any)?.response?.data?.message;
  return typeof message === 'string' && message.length > 0 ? message : fallback;
};
